import { Button, Modal } from 'antd';
import ExclamationIcon from 'assets/icons/exclamation-circle-fill.svg';

interface props {
    open: boolean;
    onCancel: () => void | Promise<void>;
    onOk: () => void | Promise<void>;
    message: string | null;
}

export const ConfirmModalComponent = ({ open, onCancel, onOk, message }: props) => {
    return (
        <Modal width={327} open={open} footer={null} centered className="modal-info">
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <img src={ExclamationIcon} alt="" />
                </div>
                <div className="description-modal" style={{ marginBottom: 32, marginTop: 32 }}>
                    物件情報のご入力ありがとうございました。<br/>
                    査定依頼いただいた物件について調査が必要なためお時間いただいております。
                    <br/>{message}
                </div>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: '100%', height: 48 }}
                    onClick={onOk}
                >
                    ダッシュボードに戻る
                </Button>
            </section>
        </Modal>
    );
};
